<template>
  <div class="shell" :class="shellClass">
    <SideNav v-if="!isMobile" />
    <TopBar />

    <main class="shell-main">
      <router-view v-slot="{ Component }">
        <!--
          탭 루트만 캐시한다(영업 홈 포함 — 매장 상세에 갔다 와도 보드 스크롤과 필터가 남는다). 탭 전환 시 스크롤 위치가 보존되고 재조회를 건너뛰어
          모바일 체감 속도가 눈에 띄게 좋아진다.
          뷰 상태를 전부 URL 쿼리에 두기 때문에(라우터 참조) 캐시된 컴포넌트도
          route.query watcher 로 정상 반응한다.
        -->
        <!--
          스택 화면(상세 · 작성)은 경로로 key 를 준다. 같은 라우트에서 :id 만 바뀌면
          vue-router 는 컴포넌트를 재사용하는데, 상세 화면이 props.id 를 지켜보지 않으면
          주소만 바뀌고 내용은 그대로다(보고 상세에서 다른 보고 알림을 눌러도 화면이 안 바뀌던 버그).
          화면마다 watch 를 챙기게 하는 대신 셸이 다시 만든다. 탭 화면은 캐시를 써야 하므로 key 를 주지 않는다
          (캘린더는 /calendar/:view 로 경로가 바뀌어도 같은 인스턴스여야 한다). 쿼리는 경로가 아니라 영향이 없다.
        -->
        <keep-alive :include="KEEP_ALIVE">
          <component :is="Component" :key="isTabs ? undefined : route.path" />
        </keep-alive>
      </router-view>
    </main>

    <BottomNav v-if="isMobile && isTabs" />
  </div>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useBreakpoint } from '@/composables/useBreakpoint'
import { useBadgeRefresh } from '@/composables/useBadgeRefresh'
import TopBar from '@/components/nav/TopBar.vue'
import BottomNav from '@/components/nav/BottomNav.vue'
import SideNav from '@/components/nav/SideNav.vue'

// 컴포넌트의 name 옵션과 일치해야 한다
const KEEP_ALIVE = ['TodayPage', 'CalendarPage', 'TasksPage', 'SalesPage']

export default {
  name: 'AppShell',
  components: { TopBar, BottomNav, SideNav },
  setup() {
    const route = useRoute()
    const { isMobile } = useBreakpoint()

    // 배지는 셸이 책임진다. 화면마다 흩어져 있으면 어느 화면에서 새로고침했느냐에
    // 따라 숫자가 보이거나 안 보인다.
    useBadgeRefresh()

    // 내 정보는 로그인할 때 한 번 받아 localStorage 에 둔다. 그 뒤에 바뀐 권한(인사관리 권한 hrAccess 등)은
    // 다시 로그인하기 전까지 안 보였다 — 앱을 열 때 조용히 한 번 더 받는다. 실패해도 로그아웃시키지 않는다.
    const store = useStore()
    onMounted(() => { store.dispatch('refreshUser') })

    const isTabs = computed(() => route.meta?.shell !== 'stack')
    const shellClass = computed(() => (isTabs.value ? 'shell--tabs' : 'shell--stack'))

    return { route, isMobile, isTabs, shellClass, KEEP_ALIVE }
  }
}
</script>
